var map = {
	"./r1.svg": "d952",
	"./r2.svg": "c975",
	"./r3.svg": "1c0e",
	"./r4.svg": "7405",
	"./r5.svg": "6e5d",
	"./r6.svg": "dd80",
	"./r7.svg": "5dd7",
	"./r8.svg": "f05c",
	"./r9.svg": "4b0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3cd8";